import _ from 'lodash';

export const STEP_KEY = {
  LOCATION: 'location',
  REASON: 'reason',
  HAS_INSURANCE: 'hasInsurance',
  INSURANCE: 'insurance',
  SOCIAL_ASSISTANCE: 'socialAssistance',
  INSURANCE_COMPLETE: 'insuranceComplete',
};

export const CHECKOUT_KEY = {
  PATIENT: 'patient',
  INSURANCE: 'insuranceDetails',
};

// Used in analytic events under the "userSuppliedLocation" key
export const generateLocationAnalytics = storage => {
  const location = storage.get(STEP_KEY.LOCATION);

  return {
    country: location.address.country,
    state: location.address.administrative_area_level_1_short,
    city: location.address.locality,
    street:
      location.address.street_number && location.address.route
        ? `${location.address.street_number} ${location.address.route}`
        : null,
    postal: location.address.postal_code ? location.address.postal_code : null,
  };
};

// Used in analytic events under the "content" key
export const generateContentAnalytics = storage => {
  const hasInsurance = storage.get(STEP_KEY.HAS_INSURANCE);
  const insuranceDetails = storage.get(STEP_KEY.INSURANCE);

  return {
    hasInsurance: getAsString(hasInsurance, 'id', 'No'), // Yes or No
    topProvider: getAsString(insuranceDetails, 'topProvider'), // true, false or undefined
    providerId: getAsString(insuranceDetails, 'provider.id'),
    providerName: getAsString(
      insuranceDetails,
      'provider.name',
      getAsString(insuranceDetails, 'insurance'),
    ),
    planId: getAsString(insuranceDetails, 'plan.id'),
    planName: getAsString(insuranceDetails, 'plan.name'),
  };
};

const getAsString = (object, path, defaultValue) => {
  const value = _.get(object, path, defaultValue);
  return value === undefined || value === null ? value : _.toString(value);
};
